import React from 'react';
import { Button } from '@progress/kendo-react-buttons';

export const InProgressComponent = () => {
    return (
        <Button
            className='font-size-0 ms-2'
            size={"small"}
            themeColor={"primary"}
            fillMode={"solid"}
            rounded={"full"}
        >
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        </Button>
    )
}

export const SavingComponent = () => {
    return (
        <Button
            className='font-size-0 saving-button ms-2'
            size={"small"}
            themeColor={"success"}
            fillMode={"solid"}
            rounded={"full"}
            iconClass="fad fa-check"
        >
        </Button>
    )
}